import { Renderer2, RendererStyleFlags2 } from '@angular/core';

/**
 * Configuration for dialog close animation
 */
export interface DialogAnimationConfig {
  content: HTMLElement;
  dialog: HTMLElement;
  duration?: number;
  renderer: Renderer2;
  variant?: 'bottom-sheet' | 'drawer';
}

export function animateDialogClose(config: DialogAnimationConfig): Promise<void> {
  const { content, dialog, duration = 280, renderer, variant = 'bottom-sheet' } = config;

  const translateOut = variant === 'drawer' ? 'translateX(100%)' : 'translateY(100%)';

  return new Promise<void>((resolve) => {
    renderer.setStyle(content, 'transition', `transform ${duration}ms cubic-bezier(0.32, 0.72, 0, 1)`);
    renderer.setStyle(content, 'transform', translateOut);
    // Custom properties need DashCase, otherwise Angular assigns style['--x'] and browsers ignore it.
    renderer.setStyle(dialog, '--backdrop-opacity', '0.3', RendererStyleFlags2.DashCase);

    const finalize = () => {
      content.removeEventListener('transitionend', finalize);
      resolve();
    };

    content.addEventListener('transitionend', finalize);

    setTimeout(() => {
      content.removeEventListener('transitionend', finalize);
      resolve();
    }, duration + 40);
  });
}
export function resetDialogStyles(
  dialog: HTMLElement,
  content: HTMLElement | null | undefined,
  renderer: Renderer2
): void {
  renderer.removeStyle(dialog, '--backdrop-opacity', RendererStyleFlags2.DashCase);
  renderer.removeStyle(dialog, 'transform');
  renderer.removeStyle(dialog, 'padding-bottom');

  if (content) {
    renderer.removeStyle(content, 'transform');
    renderer.removeStyle(content, 'transition');
    renderer.removeStyle(content, 'max-height');
  }
}
